var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "child-view" },
    [
      _c("router-view"),
      _vm._v(" "),
      _c("Toast"),
      _vm._v(" "),
      _c("policy-popup", {
        attrs: { isShow: _vm.showpPolicyPopup },
        on: {
          onConfirm: _vm.handleConfirmPolicy,
          onCancel: _vm.handleRefusePolicy,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }